export default values => ({
  phone: values.phone ?? '',
  email: values.email ?? '',
  facebook: values.facebook ?? '',
  instagram: values.instagram ?? '',
  homePhone: values.homePhone ?? '',
  officePhone: values.officePhone ?? ''
});
